import { useState } from 'react';

/**
 * A reader's choice that the next entity page opens with (hero view, legend, speed profiles):
 * kept in localStorage; without storage it holds for this page only.
 */
export function useStored<T>(key: string, initial: T): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(key);
      return stored === null ? initial : (JSON.parse(stored) as T);
    } catch {
      return initial;
    }
  });
  const set = (next: T) => {
    setValue(next);
    try {
      localStorage.setItem(key, JSON.stringify(next));
    } catch {
      // The choice still applies to this page.
    }
  };
  return [value, set];
}
